import { DiscardDialog, hasUnsavedChanges } from '@kanos/web-core';
import { useBlocker } from '@tanstack/react-router';
import { leavesUnsaved } from './leaving';

/**
 * Asks before a way out of the page while something is unsaved (after Corly): a link in the
 * sidebar, the palette, the browser's back button - not a change of the search alone
 * (`leavesUnsaved`). Closing or reloading the tab is held by the forms themselves
 * (`useUnsavedChanges`), in the browser's own words.
 */
export function LeaveGuard() {
  const blocker = useBlocker({
    shouldBlockFn: ({ current, next }) => leavesUnsaved(current, next, hasUnsavedChanges()),
    enableBeforeUnload: false,
    withResolver: true,
  });
  if (blocker.status !== 'blocked') return null;
  return <DiscardDialog onKeep={blocker.reset} onDiscard={blocker.proceed} />;
}
